<template>
  <div class="row">
    <div class="col">
      <div class="card" style="width: 20rem;">
        <div class="catalog-card-body">
          <h4 class="card-title">{{catalog.name}}</h4>
          <h6 class="card-subtitle mb-2 text-muted">{{catalog.app_catalog['uid']}}</h6>
        </div>
      </div>
    </div>

    <div class="w-100"></div>
    <div class="col">
      <div class="card" v-if="catalog.startup_offers.length > 0">
        <div class="card-header">
          <strong>Startup Offers</strong>
        </div>
          <div class="card-body">
            <table class="table table-bordered table-striped table-condensed">
              <tr v-for="startup in catalog.startup_offers">
                <td>
                  <div class="text-center">
                    <product-offer-icon v-bind:icon="startup.product_offer.icon" width="60px"></product-offer-icon>
                    <h4 class="card-title">{{startup.product_offer_name}}</h4>
                    <h6 class="card-subtitle mb-2 text-muted">{{startup.product_offer.codename}}</h6>
                    <router-link :to="{ name: 'Offer', params: {id: startup.product_offer.id} }">{{startup.product_offer.id}}</router-link>
                  </div>
                </td>
                <td>
                  <div class="text-center">
                    <h4 class="card-title">{{startup.sale_option.type}}</h4>
                    <sale-option v-bind:codename="startup.sale_option.codename" v-bind:duration="startup.sale_option.duration"/></br>
                    <router-link :to="{ name: 'Offer', params: {id: startup.sale_option.product_offer_id} }">{{startup.sale_option.id}}</router-link>
                  </div>
                </td>
                <td>
                  <span v-for="version in startup.versions" class="badge badge-pill version" v-bind:style="changeStyle(setColor(version, getUniqueVersions(startup.versions)))">
                    {{version}}
                  </span>
                </td>
              </tr>
            </table>
          </div>
      </div>
    </div>
    <div class="w-100"></div>
    <div class="col">
      <div class="card" v-if="catalog.bundle_offers.length > 0">
        <div class="card-header">
          <strong>Bundle Offers</strong>
        </div>
          <div class="card-body">
            <table class="table table-bordered table-striped table-condensed">
              <tr v-for="bundle in catalog.bundle_offers">
                <td>
                  <div class="text-center">
                    <product-offer-icon v-bind:icon="bundle.product_offer.icon" width="60px"></product-offer-icon>
                    <h4 class="card-title">{{bundle.name}}</h4>
                    <h6 class="card-subtitle mb-2 text-muted">{{bundle.product_offer.codename}}</h6>
                    <router-link :to="{ name: 'Offer', params: {id: bundle.product_offer.id} }">{{bundle.product_offer.id}}</router-link>
                  </div>
                </td>
                <td>
                  <span v-for="version in bundle.versions" class="badge badge-pill version" v-bind:style="changeStyle(setColor(version, getUniqueVersions(bundle.versions)))">
                    {{version}}
                  </span>
                </td>
              </tr>
            </table>
          </div>
      </div>
    </div>
  </div>
</template>

<style>
  .version {
    margin-right: 1px;
  }

  .catalog-card-body {
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem 1.25rem 0 1.25rem;
  }
</style>


<script>
import catalogs from 'services/catalogs'
import ProductOfferIcon from 'components/ProductOfferIcon'
import ProductOfferItem from 'components/ProductOfferItem'
import SaleOption from 'components/SaleOption'

export default {
  name: 'catalog',
  created () {
    this.getCatalog()
  },
  data () {
    return {
      catalog: {},
      backgroundColor: '',
      colors: [
        '#BF360C', '#FFB74D', '#FF6F00', '#9CCC65', '#558B2F', '#00695C',
        '#4DB6AC', '#0277BD', '#29B6F6', '#283593', '#7986CB', '#B39DDB',
        '#6A1B9A', '#CE93D8', '#AD1457', '#F48FB1', '#c62828', '#ef9a9a',
        '#455A64', '#90A4AE', '#616161', '#9E9E9E', '#5D4037', '#A1887F'
      ]
    }
  },
  computed: {
  },
  components: {
    ProductOfferIcon,
    ProductOfferItem,
    SaleOption
  },
  methods: {
    getCatalog () {
      catalogs.get(this, this.$route.params.id)
    },
    getUniqueVersions (versions) {
      var unique = versions.map(v => v.split('.', 2).join('.'))
      return Array.from(new Set(unique))
    },
    getIndex (listVersions, element) {
      return listVersions.indexOf(element)
    },
    getColors (index) {
      return this.colors[index]
    },
    setColor (version, versions) { // TODO add more colors
      var miniVersion = version.split('.', 2).join('.')
      var index = this.getIndex(versions, miniVersion)

      if (index < this.colors.length) {
        return this.getColors(index)
      } else {
        return this.getColors(index - this.colors.length)
      }
    },
    changeStyle (color) {
      return { 'background-color': color }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/catalogs/Catalog.vue